import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { Loader, Dimmer } from "semantic-ui-react";
import {
  saveNewCustomerData,
  saveEditedCustomerData,
  setIsLoadingOnCustomerProfile,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile
} from "../../../actions/customerProfile";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  updateWhereToGoFromCustomerPageModal,
  updateCurrentMenu
} from "../../../actions/menu";
import objectAssign from "object-assign";
import { forceValidation } from "../../shared/validMeReact";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import { menuNamesEnum } from "../../../state/initialState";

@connect(mapStateToProps)
export default class BottomPanelBookingOnlyCustomerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { hoveredSave: false };
  }

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  saveClickHandler = () => {
    let {
      bookingOnlyCustomerProfileData,
      appointmentStepData: { selectedCustomer },
      appointmentStepData,
      limitedPermissions,
      currentBookingId
    } = this.props;

    selectedCustomer.email = bookingOnlyCustomerProfileData.email;
    selectedCustomer.phone = bookingOnlyCustomerProfileData.phoneNumber;
    selectedCustomer.firstname = bookingOnlyCustomerProfileData.firstName;
    selectedCustomer.lastname = bookingOnlyCustomerProfileData.lastName;

    let canCreateCustomerByUsingBookingFormFields =
      !limitedPermissions.canCreateCustomerProfile &&
      !limitedPermissions.canSearchForCustomers &&
      (this.canEditCurrentBooking() || !currentBookingId);
    let newData = objectAssign({}, this.props.appointmentStepData, {
      selectedCustomer: selectedCustomer,
      address: bookingOnlyCustomerProfileData.address //(canCreateCustomerByUsingBookingFormFields ? bookingOnlyCustomerProfileData.address : appointmentStepData.address),
    });
    this.props.dispatch(updateAppointmentStepData(newData));

    this.props.dispatch(
      updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile(true)
    );
    setTimeout(() => {
      this.props.dispatch(
        updateCurrentMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
      );
    }, 0); // this is required because the cb is not called after the customer has been updated in the app state, but rather, before that, so we wait until the next JS app cycle

    sessionStorage.setItem(
      "BOOKING_ONLY_CUSTOMER_PROFILE_SNAPSHOT",
      JSON.stringify(bookingOnlyCustomerProfileData)
    );
  };

  handleSaveMouseIn = () => {
    this.setState({ hoveredSave: true });
  };
  handleSaveMouseOut = () => {
    this.setState({ hoveredSave: false });
  };

  render() {
    let {
      CustomerProfile: {
        EditBookingCustomerProfileAccessRestrictedMessage,
        SaveButtonText
      }
    } = window.APP.LANGUAGE.Pages;
    let {
      limitedPermissions,
      appointmentStepData,
      currentBookingId
    } = this.props;

    let saveButton = "";
    let saveButtonClasses = "ui right floated button btn-default save-customer";
    if (
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId
    ) {
      // if the user cannot edit the currently opened booking, cannot edit profile

      saveButtonClasses += " disabled";
      saveButton = (
        <div
          className="tooltip-container"
          onMouseOver={this.handleSaveMouseIn}
          onMouseOut={this.handleSaveMouseOut}
        >
          <div className={saveButtonClasses}>{SaveButtonText}</div>
          {this.state.hoveredSave ? (
            <div className="booking_tooltip_text">
              {EditBookingCustomerProfileAccessRestrictedMessage}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      saveButton = (
        <div
          onClick={this.saveClickHandler}
          data-group="customerProfileNames&customerProfile&customerProfileContacts"
          className={saveButtonClasses}
        >
          {SaveButtonText}
        </div>
      );
    }
    return (
      <div className="ui clearing aligned booking_footer">
        <br />
        <div className="action_buttons">{saveButton}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
    currentBookingId: state.bookingReducer.currentBookingId,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions
  };
}
